import { render, staticRenderFns } from "./FormBranch.vue?vue&type=template&id=241c971b&scoped=true&"
import script from "./FormBranch.vue?vue&type=script&lang=js&"
export * from "./FormBranch.vue?vue&type=script&lang=js&"
import style0 from "./FormBranch.vue?vue&type=style&index=0&id=241c971b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c971b",
  null
  
)

export default component.exports